import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { QueryParameters as CartPageQueryParams } from "@faire/web-api--source/routes/www/cart";

export const useCartPageSearchQuery = () => {
  const { query } = useQueryParams(CartPageQueryParams.parse);
  return query;
};
